// extracted by mini-css-extract-plugin
module.exports = {"sectionLabel":"Form_sectionLabel__2NUip","sections":"Form_sections__2JTmT","card":"Form_card__1IoV_","fieldsetLabel":"Form_fieldsetLabel__1XOtx"};